'use strict';

var React = require('react');

var SvgCashDollarMinor = function SvgCashDollarMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-13c.46 0 .833.373.833.833v.164a3.79 3.79 0 0 1 1.423.914.833.833 0 1 1-1.179 1.178s-.472-.589-1.09-.589c-.487 0-.82.377-.82.833 0 .406.117.505.187.558.152.114.39.186.848.3l.055.014c.377.094.939.233 1.389.571.554.416.854 1.046.854 1.89a2.5 2.5 0 0 1-1.667 2.358v.143a.833.833 0 0 1-1.666 0v-.164a3.79 3.79 0 0 1-1.423-.914.833.833 0 0 1 1.179-1.178c.314.315.615.46.82.528a1.357 1.357 0 0 0 .27.06.833.833 0 0 0 .82-.832c0-.406-.117-.505-.187-.558-.152-.114-.39-.186-.848-.3l-.055-.014c-.377-.094-.939-.233-1.389-.571-.554-.416-.854-1.046-.854-1.89a2.5 2.5 0 0 1 1.667-2.358v-.143c0-.46.373-.833.833-.833Z"
  }));
};

exports.SvgCashDollarMinor = SvgCashDollarMinor;
